import { UnderDevelopment } from "@/shared/components";


function RequestPage() {
    return (
        <div className="basicWrapper">
            <UnderDevelopment featureName="Request page" />
        </div>
    )
}

export default RequestPage;